module.exports = __webpack_public_path__ + "img/flsmidth.36d34179.jpg";